import { useState } from 'react';
import { logger } from '@fiverr-private/obs';
import type { Currency as CurrencyType } from '@fiverr-private/currencies_plugin';

// backward-compatibility
export type { CurrencyType as Currency };

export const OPEN_DRAWER_EVENT_NAME = 'openBriefCreationDrawer';
export const WINDOW_INDICATION = 'isBriefCreationDrawerLoaded';

export const isDrawerMounted = () => !!window[WINDOW_INDICATION];

export interface DrawerProps {
    id?: string;
    source: string;
    currency: CurrencyType;
    isOpen: boolean;
    setIsLoading?: (isLoading: boolean) => void;
    onClose?: (result: any) => void;
    initialPrompt?: string;
    onOpen?: () => void;
}

export type OpenDrawerParams = Omit<DrawerProps, 'isOpen'>;

export const openBriefCreationDrawer = ({
    currency,
    source,
    setIsLoading,
    id,
    onClose,
    initialPrompt,
    onOpen,
}: OpenDrawerParams) => {
    if (!isDrawerMounted()) {
        logger.error('Creation drawer is not mounted');
        return false;
    }

    const event = new CustomEvent<DrawerProps>(OPEN_DRAWER_EVENT_NAME, {
        detail: {
            id,
            source,
            currency,
            isOpen: true,
            setIsLoading,
            onClose,
            initialPrompt,
            onOpen,
        },
    });
    window.dispatchEvent(event);
    return true;
};

export const useOpenBriefCreationDrawer = (id?: string) => {
    const [isLoading, setIsLoading] = useState(false);

    const openBriefCreationDrawerInternal = ({
        currency,
        source,
        onClose,
        initialPrompt,
        onOpen,
    }: OpenDrawerParams) => {
        openBriefCreationDrawer({ currency, source, id, setIsLoading, onClose, initialPrompt, onOpen });
    };

    return { openBriefCreationDrawer: openBriefCreationDrawerInternal, isLoading };
};
